import _default from '../../system/createStyled.esm.js';
import defaultTheme from './defaultTheme.esm.js';
import THEME_ID from './identifier.esm.js';
import rootShouldForwardProp from './rootShouldForwardProp.esm.js';
export { default as rootShouldForwardProp } from './rootShouldForwardProp.esm.js';

const styled = _default({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
var styledComponent = styled;

export { styledComponent as default };
